export const CAMPAIGN_STATUSES = ["NOT_CALLED", "QUEUED", "SKIPPED", "ACTIVE", "ANSWERED", "DECLINED", "NOT_ANSWERING", "FAILED"];

export const statusLabels = {
  NOT_CALLED: "Not called",
  QUEUED: "Queued",
  SKIPPED: "Skipped",
  ACTIVE: "Ringing",
  ANSWERED: "Answered",
  DECLINED: "Declined",
  NOT_ANSWERING: "Not answering",
  FAILED: "Failed",
};

export const statusColors = {
  NOT_CALLED: "default",
  QUEUED: "primary",
  SKIPPED: "default",
  ACTIVE: "info",
  ANSWERED: "success",
  DECLINED: "secondary",
  NOT_ANSWERING: "warning",
  FAILED: "error",
};

export const initialCampaignForm = {
  name: "",
  description: "",
  fromNumber: "",
  extensionId: "",
  startDate: "",
  endDate: "",
  startTime: "09:00",
  endTime: "17:00",
  maxAttempts: 1,
  // registry projects only: the sub project the campaign calls through
  subProjectId: "",
  // registry projects only: hex color on the calendar, "" = the default color
  color: "",
};

// How often a page re-fetches while a call is ringing (ACTIVE)
export const ACTIVE_POLL_INTERVAL = 5000;

// What Asterisk reported for an attempt (OutboundCallAttempt.callOutcome)
export const callOutcomeLabels = {
  answered: "Answered",
  no_answer: "No answer",
  busy: "Busy",
  hangup: "Hung up",
  congestion: "Congestion",
  failed: "Failed",
  unknown: "Unknown",
};

export const headerCellSx = {fontWeight: 700, fontSize: 12};
